import * as React from 'react'

import { IItem } from 'searchResults'

import Card from '../../categoryPage/elementsPromoItemsBlock/card/card'
import AudioCard from '../../categoryPage/elementsPromoItemsBlock/audioCard/audioCard'

import * as styles from './freeItemsBlock.module.css'

interface IProps {
  data: IItem[]
  title: string
  subtitle?: string
  reportItemClick: (index: number, item: IItem, listName: string) => any
}

const FreeItemsBlock: React.SFC<IProps> = ({
  data,
  title,
  subtitle,
  reportItemClick
}) => {
  const itemsWithRatios = data.map(item => ({
    ...item,
    imageRatios: {
      previewRatio: 300 / 590
    },
    marketID: 0,
    title: item.name,
    author: item.author_username,
    itemURL: item.url
  }))

  return (
    <section className={styles.root}>
      <div className={styles.freeItemsWrapper}>
        <header>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </header>
        <div className={styles.items}>
          {itemsWithRatios.map((item, index) => {
            const isAudioItem = item.site === 'audiojungle.net'
            const width = index > 2 ? 25 : 33.33

            const onClickHandler = () =>
              reportItemClick(index, item, 'Homepage: Free files of the month')

            return (
              <div className={styles.item} key={index}>
                {isAudioItem ? (
                  <AudioCard
                    {...item}
                    width={width}
                    onClick={onClickHandler}
                    showCTA={false}
                  />
                ) : (
                  <Card
                    {...item}
                    width={width}
                    onClick={onClickHandler}
                    showCTA={false}
                  />
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default FreeItemsBlock
